"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _react = _interopRequireWildcard(require("react")),
    _uiKit = require("@devsta/ui-kit"),
    _screenfull = _interopRequireDefault(require("screenfull")),
    _hls = _interopRequireDefault(require("hls.js")),
    _createHlsStream = _interopRequireDefault(require("@devsta/create-hls-stream")),
    _classnames = _interopRequireDefault(require("classnames")),
    _lodash = _interopRequireDefault(require("lodash.get")),
    _utils = require("../../../common/utils"),
    _skipAmount = _interopRequireDefault(require("../constants/skipAmount")),
    _PlayerContextMenu = _interopRequireDefault(require("./PlayerContextMenu")),
    _Controls = _interopRequireDefault(require("./Controls")),
    _SeekBar = _interopRequireDefault(require("./SeekBar")),
    _VideoPlaceholder = _interopRequireDefault(require("../../VideoPlaceholder")),
    _Comments = require("../../Comments");

require("../styles/_player.scss");

var _streamQualityLevels = require("../../../common/constants/streamQualityLevels"),
    _attemptToPlayVideo = _interopRequireDefault(require("../../../common/utils/attemptToPlayVideo"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var source, i = 1; i < arguments.length; i++) {
    source = null == arguments[i] ? {} : arguments[i], i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2["default"])(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _createSuper(Derived) {
  return function () {
    var result,
        Super = (0, _getPrototypeOf2["default"])(Derived);

    if (_isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else result = Super.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (e) {
    return !1;
  }
}

var resolutions = [{
  level: _streamQualityLevels.STREAM_LEVEL_1080P,
  label: "1080p",
  isLevelHD: !0
}, {
  level: _streamQualityLevels.STREAM_LEVEL_720P,
  label: "720p",
  isLevelHD: !0
}, {
  level: _streamQualityLevels.STREAM_LEVEL_480P,
  label: "480p",
  isLevelHD: !1
}, {
  level: _streamQualityLevels.STREAM_LEVEL_360P,
  label: "360p",
  isLevelHD: !1
}, {
  level: _streamQualityLevels.STREAM_LEVEL_240P,
  label: "240p",
  isLevelHD: !1
}, {
  level: _streamQualityLevels.STREAM_LEVEL_AUTO,
  label: "Auto",
  isLevelHD: !1
}],
    KEY_CODES = {
  space: 32,
  left: 37,
  right: 39,
  up: 38,
  down: 40,
  f: 70,
  h: 72,
  m: 77
},
    ASSET_POLL_FREQUENCY = 5e3;

function hasTranscodedVideoFiles(asset) {
  var assetFiles = (asset || {}).assetFiles;
  return assetFiles && assetFiles.HD && assetFiles.SD && assetFiles.STREAM;
}

function getSourceFile(_ref2) {
  var _ref2$asset = _ref2.asset;
  _ref2$asset = void 0 === _ref2$asset ? {} : _ref2$asset;
  var assetFiles = _ref2$asset.assetFiles,
      isHD = _ref2.isHD,
      excludeManifests = _ref2.excludeManifests;
  return assetFiles ? _hls["default"].isSupported() && assetFiles.STREAM && assetFiles.STREAM.fragments.length ? excludeManifests ? {} : assetFiles.STREAM : isHD ? assetFiles.HD || assetFiles.ORIGINAL || {} : assetFiles.SD || assetFiles.ORIGINAL || {} : {};
}

var PlayerComponent = function (_Component) {
  function PlayerComponent() {
    var _this;

    return (0, _classCallCheck2["default"])(this, PlayerComponent), _this = _super.call(this), _this.handleUpdatedAsset = function () {
      _this._hls && _this._hls.destroy(), _this.setState({
        hlsInitialized: !1,
        hlsRequired: !0
      });

      var asset = _this.props.asset,
          _getSourceFile = getSourceFile({
        asset: asset
      }),
          type = _getSourceFile.type;

      "STREAM" !== type || _this.initStream();
    }, _this.completeManualQualityChange = function () {
      var wasPlaying = _this.state.wasPlaying;

      _this.setState({
        isLevelManuallySwitching: !1,
        buffering: !1,
        isPlaying: wasPlaying
      });
    }, _this.onLevelSwitched = function (_, data) {
      var isLevelManuallySwitching = _this.state.isLevelManuallySwitching;
      return isLevelManuallySwitching && _this.completeManualQualityChange(), data.level === _streamQualityLevels.STREAM_LEVEL_720P || data.level === _streamQualityLevels.STREAM_LEVEL_1080P ? void _this.setState({
        isStreamHighDef: !0
      }) : void _this.setState({
        isStreamHighDef: !1
      });
    }, _this.initStream = function () {
      var asset = _this.props.asset,
          _this$state = _this.state,
          hlsInitialized = _this$state.hlsInitialized,
          hlsRequired = _this$state.hlsRequired;

      if (hasTranscodedVideoFiles(asset) && !hlsInitialized && hlsRequired) {
        var _getSourceFile2 = getSourceFile({
          asset: asset
        }),
            type = _getSourceFile2.type,
            sourceUrl = _getSourceFile2.sourceUrl,
            fragments = _getSourceFile2.fragments;

        if (!_hls["default"].isSupported() || "STREAM" !== type) return void _this.setState({
          hlsRequired: !1
        });

        if (_this._videoRef) {
          var currentTime = _this.state.currentTime,
              hls = (0, _createHlsStream["default"])(fragments, currentTime, -1, sourceUrl, _this._videoRef);
          _this.setState({
            hlsInitialized: !0
          }), _this._hls = hls, hls.on(_hls["default"].Events.LEVEL_SWITCHED, _this.onLevelSwitched);
        }
      }
    }, _this.addCaptionToState = function (vtt, caption) {
      vtt && _this.setState(function (_ref3) {
        var captionSourceFiles = _ref3.captionSourceFiles;
        return {
          captionSourceFiles: _objectSpread({}, captionSourceFiles, (0, _defineProperty2["default"])({}, caption.assetFileId, caption.sourceUrl))
        };
      });
    }, _this.fetchCaptions = function (asset) {
      asset && asset.assetFiles.VTT_CAPTION && asset.assetFiles.VTT_CAPTION.length && asset.assetFiles.VTT_CAPTION.forEach(function (caption) {
        var client = new XMLHttpRequest();
        client.open("GET", caption.sourceUrl), client.onreadystatechange = function () {
          var responseText = client.responseText;

          _this.addCaptionToState(responseText, caption);
        }, client.send();
      });
    }, _this.onSelectCaption = function (caption) {
      return function () {
        _this.setState(function (_ref4) {
          var selectedCaption = _ref4.selectedCaption;
          return {
            selectedCaption: selectedCaption === caption ? void 0 : caption
          };
        });
      };
    }, _this.handleAssetPoll = function () {
      var _this$props = _this.props,
          asset = _this$props.asset,
          fetchAssets = _this$props.fetchAssets,
          assetId = _this$props.assetId;
      return hasTranscodedVideoFiles(asset) ? void _this.initStream() : void (_this._assetPollInterval = setInterval(function () {
        var latestAsset = _this.props.asset;
        return hasTranscodedVideoFiles(latestAsset) ? (clearInterval(_this._assetPollInterval), void (_this._assetPollInterval = null)) : void fetchAssets({
          assetId: assetId
        });
      }, ASSET_POLL_FREQUENCY));
    }, _this.videoWaiting = function () {
      _this.setState({
        buffering: !0,
        isPlaying: !1
      });
    }, _this.videoResuming = function () {
      _this.setState({
        buffering: !1,
        isPlaying: !0
      });
    }, _this.stopBuffering = function () {
      if (_this._videoRef) {
        var hlsInitialized = _this.state.hlsInitialized;

        _this.setState({
          buffering: !1,
          totalDuration: _this._videoRef.duration,
          isVideoStream: hlsInitialized,
          isVideoFile: !hlsInitialized
        });

        var isPlaying = _this.state.isPlaying;
        isPlaying && _this._videoRef && (0, _attemptToPlayVideo["default"])(_this._videoRef);
      }
    }, _this.setCurrentTime = function () {
      var _this$state2 = _this.state,
          isPlaying = _this$state2.isPlaying,
          buffering = _this$state2.buffering;

      if (_this._videoRef && isPlaying && !buffering) {
        var currentTime = _this._videoRef.currentTime;

        _this.setState(function (_ref5) {
          var totalDuration = _ref5.totalDuration,
              latestIsPlaying = _ref5.isPlaying;
          return {
            currentTime: currentTime,
            isPlaying: !(currentTime >= totalDuration) && latestIsPlaying
          };
        });
      }
    }, _this.setCustomTime = function (time) {
      var _this$state3 = _this.state,
          totalDuration = _this$state3.totalDuration,
          currentTime = _this$state3.currentTime,
          minifiedTime = 0 > time ? 0 : time,
          normalisedTime = minifiedTime > totalDuration ? totalDuration : minifiedTime;
      currentTime !== normalisedTime && (_this.setState({
        currentTime: normalisedTime
      }), _this._videoRef && (_this._videoRef.currentTime = normalisedTime));
    }, _this.setVideoRef = function (videoRef) {
      videoRef && (videoRef.addEventListener("ended", videoRef.pause), videoRef.addEventListener("timeupdate", _this.setCurrentTime), videoRef.addEventListener("loadeddata", _this.stopBuffering), videoRef.addEventListener("waiting", _this.videoWaiting), videoRef.addEventListener("playing", _this.videoResuming), _this._videoRef = videoRef, videoRef.focus());
    }, _this.setPlayerRef = function (playerRef) {
      playerRef && (_this._playerRef = playerRef);
    }, _this.toggleVideoPlay = function () {
      if (_this._videoRef) {
        var isPlaying = _this.state.isPlaying,
            newPlaying = !isPlaying;
        newPlaying ? (0, _attemptToPlayVideo["default"])(_this._videoRef) : _this._videoRef.pause(), _this.setState({
          isPlaying: newPlaying,
          controlsVisible: !0
        }, function () {
          setTimeout(function () {
            var _this$state4 = _this.state,
                currentPlaying = _this$state4.isPlaying,
                hoveringVideo = _this$state4.hoveringVideo,
                controlsVisible = _this$state4.controlsVisible;
            currentPlaying && controlsVisible && !hoveringVideo && _this.setState({
              controlsVisible: !1
            });
          }, 750);
        });
      }
    }, _this.hoverPlayer = function () {
      var hoveringVideo = _this.state.hoveringVideo;
      hoveringVideo || _this.setState({
        hoveringVideo: !0,
        controlsVisible: !0
      });
    }, _this.stopHoverPlayer = function () {
      var hoveringVideo = _this.state.hoveringVideo;
      hoveringVideo && _this.setState({
        hoveringVideo: !1
      }, function () {
        setTimeout(function () {
          var _this$state5 = _this.state,
              currentPlaying = _this$state5.isPlaying,
              currentlyHovering = _this$state5.hoveringVideo,
              controlsVisible = _this$state5.controlsVisible;
          currentPlaying && controlsVisible && !currentlyHovering && _this.setState({
            controlsVisible: !1
          });
        }, 750);
      });
    }, _this.pauseVideo = function () {
      var isPlaying = _this.state.isPlaying;
      isPlaying && _this.toggleVideoPlay();
    }, _this.toggleFullscreen = function () {
      return _this._playerRef ? void _this.setState(function (_ref6) {
        var isFullscreen = _ref6.isFullscreen;
        return {
          isFullscreen: !isFullscreen
        };
      }, function () {
        var isFullscreen = _this.state.isFullscreen;
        return isFullscreen ? void _screenfull["default"].request(_this._playerRef) : void _screenfull["default"].exit();
      }) : void 0;
    }, _this.toggleComments = function () {
      var isCommentsEnabled = _this.state.isCommentsEnabled;

      _this.setState({
        isCommentsEnabled: !isCommentsEnabled
      });
    }, _this.onSelectResolution = function (resolution) {
      return function () {
        if (_this._hls) {
          _this._hls.currentLevel = resolution.level;
          var isPlaying = _this.state.isPlaying;

          _this.setState({
            buffering: !0,
            wasPlaying: isPlaying,
            isPlaying: !1,
            isLevelManuallySwitching: !0,
            selectedResolution: resolution
          });
        }
      };
    }, _this.toggleVolume = function () {
      var volume = _this.state.volume;

      _this.setVolume(0 === volume ? 1 : 0);
    }, _this.setVolume = function (newVolume) {
      var fixedVolume = parseFloat(newVolume.toFixed(1));
      _this._videoRef && (_this._videoRef.volume = fixedVolume, _this.setState({
        volume: fixedVolume
      }));
    }, _this.toggleHD = function () {
      var _this$state6 = _this.state,
          isHD = _this$state6.isHD,
          currentTime = _this$state6.currentTime;

      _this.setState({
        isHD: !isHD,
        buffering: !0,
        playFromWhenBuffered: currentTime
      });
    }, _this.videoOnKeyDown = function (event) {
      var commentModalId = _this.props.commentModalId;

      if (_this._videoRef && !commentModalId) {
        event.preventDefault(), event.stopPropagation();
        var keyCode = event.keyCode,
            _this$state7 = _this.state,
            currentTime = _this$state7.currentTime,
            volume = _this$state7.volume;
        return keyCode === KEY_CODES.space ? void _this.toggleVideoPlay() : keyCode === KEY_CODES.left ? void _this.setCustomTime(currentTime - _skipAmount["default"]) : keyCode === KEY_CODES.right ? void _this.setCustomTime(currentTime + _skipAmount["default"]) : keyCode === KEY_CODES.m ? void _this.toggleVolume() : keyCode === KEY_CODES.up && 1 > volume ? void _this.setVolume(volume + .1) : keyCode === KEY_CODES.down && 0 < volume ? void _this.setVolume(volume - .1) : keyCode === KEY_CODES.f ? void _this.toggleFullscreen() : keyCode === KEY_CODES.h ? void _this.toggleHD() : void 0;
      }
    }, _this.getSource = function () {
      var _this$state8 = _this.state,
          playFromWhenBuffered = _this$state8.playFromWhenBuffered,
          isHD = _this$state8.isHD,
          asset = _this.props.asset;
      if (!asset) return "";

      var _getSourceFile3 = getSourceFile({
        asset: asset,
        isHD: isHD,
        excludeManifests: !0
      }),
          sourceUrl = _getSourceFile3.sourceUrl;

      return "".concat(sourceUrl).concat(playFromWhenBuffered ? "#t=".concat(playFromWhenBuffered) : "");
    }, _this.state = {
      isPlaying: !1,
      isFullscreen: !1,
      currentTime: 0,
      volume: 1,
      totalDuration: 0,
      isHD: !1,
      isCommentsEnabled: !0,
      buffering: !0,
      hlsInitialized: !1,
      hlsRequired: !0,
      isVideoStream: !1,
      isVideoFile: !1,
      isStreamHighDef: !1,
      isLevelManuallySwitching: !1,
      wasPlaying: !1,
      selectedResolution: resolutions.find(function (resolution) {
        return resolution.level === _streamQualityLevels.STREAM_LEVEL_AUTO;
      }),
      captionSourceFiles: {},
      controlsVisible: !0,
      hoveringVideo: !0
    }, _this;
  }

  (0, _inherits2["default"])(PlayerComponent, _Component);

  var _super = _createSuper(PlayerComponent);

  return (0, _createClass2["default"])(PlayerComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.handleAssetPoll();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_ref7) {
      var prevAssetId = _ref7.assetId,
          prevAsset = _ref7.asset,
          _this$props2 = this.props,
          assetId = _this$props2.assetId,
          asset = _this$props2.asset,
          _this$state9 = this.state,
          hlsInitialized = _this$state9.hlsInitialized,
          hlsRequired = _this$state9.hlsRequired;
      hasTranscodedVideoFiles(asset) && hlsRequired && !hlsInitialized && this.initStream(), asset && !prevAsset && this.fetchCaptions(asset), prevAssetId === assetId || (this._assetPollInterval && clearInterval(this._assetPollInterval), this.handleAssetPoll(), this.handleUpdatedAsset());
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._hls && this._hls.destroy(), this._assetPollInterval && clearInterval(this._assetPollInterval);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state10 = this.state,
          isPlaying = _this$state10.isPlaying,
          currentTime = _this$state10.currentTime,
          totalDuration = _this$state10.totalDuration,
          isFullscreen = _this$state10.isFullscreen,
          isCommentsEnabled = _this$state10.isCommentsEnabled,
          isHD = _this$state10.isHD,
          buffering = _this$state10.buffering,
          volume = _this$state10.volume,
          isVideoStream = _this$state10.isVideoStream,
          isVideoFile = _this$state10.isVideoFile,
          selectedResolution = _this$state10.selectedResolution,
          isStreamHighDef = _this$state10.isStreamHighDef,
          selectedCaption = _this$state10.selectedCaption,
          controlsVisible = _this$state10.controlsVisible,
          _this$props3 = this.props,
          asset = _this$props3.asset,
          customPlaceholder = _this$props3.customPlaceholder,
          onAddComment = _this$props3.onAddComment,
          commentModalId = _this$props3.commentModalId,
          onDeleteComment = _this$props3.onDeleteComment,
          assetId = _this$props3.assetId,
          selectedClip = _this$props3.selectedClip,
          showComments = _this$props3.showComments,
          filterByClipId = _this$props3.filterByClipId;
      return void 0 === asset ? null : null === asset || (0, _utils.isAssetMissing)(asset) ? customPlaceholder || _react["default"].createElement(_VideoPlaceholder["default"], {
        icon: asset ? "faq" : "corrupt",
        iconColor: "michael",
        text: asset ? "This video seems to be missing." : "This video has been removed.",
        subtitle: "Get in touch with the owner if this isn't what you're expecting."
      }) : hasTranscodedVideoFiles(asset) ? _react["default"].createElement(_PlayerContextMenu["default"], {
        isDisabled: null === asset
      }, _react["default"].createElement("div", {
        role: "button",
        className: "player",
        ref: this.setPlayerRef,
        onKeyDown: this.videoOnKeyDown,
        onMouseOver: this.hoverPlayer,
        onFocus: this.hoverPlayer,
        onMouseOut: this.stopHoverPlayer,
        onBlur: this.stopHoverPlayer,
        tabIndex: 0
      }, null !== asset && _react["default"].createElement("video", {
        className: "player__video",
        ref: this.setVideoRef,
        src: this.getSource(),
        crossOrigin: "anonymous"
      }, _react["default"].createElement("track", {
        kind: "subtitles",
        src: selectedCaption && selectedCaption.sourceUrl,
        default: !0
      })), isCommentsEnabled && showComments && null !== asset ? _react["default"].createElement(_Comments.CommentsOverlay, {
        assetId: assetId,
        selectedClip: selectedClip,
        pauseTime: this.pauseVideo,
        time: currentTime,
        onAddComment: onAddComment,
        onDeleteComment: onDeleteComment,
        isPlaying: isPlaying,
        totalDuration: totalDuration,
        selector: ".player__floating",
        commentsOverlayClass: "player__floating__comments",
        setCustomTime: this.setCustomTime,
        filterByClipId: filterByClipId
      }) : null, buffering && null !== asset ? _react["default"].createElement(_uiKit.Icon, {
        className: "player__buffering",
        size: 36,
        name: "shootstagrad",
        color: "white",
        spin: !0
      }) : null, null === asset ? _react["default"].createElement(_uiKit.Icon, {
        className: "player__buffering",
        size: 50,
        name: "corrupt",
        color: "michael"
      }) : null, _react["default"].createElement("div", {
        className: (0, _classnames["default"])("player__floating", {
          "player__floating--hidden": !controlsVisible,
          "player__floating--disabled": null === asset
        })
      }, _react["default"].createElement(_SeekBar["default"], {
        currentTime: currentTime,
        totalDuration: totalDuration,
        isPlaying: isPlaying,
        onSetManualTime: this.setCustomTime,
        commentModalId: commentModalId,
        isBuffering: buffering
      }), _react["default"].createElement(_Controls["default"], {
        asset: asset,
        currentTime: currentTime,
        toggleVideoPlay: this.toggleVideoPlay,
        toggleFullscreen: this.toggleFullscreen,
        toggleHD: this.toggleHD,
        toggleVolume: this.toggleVolume,
        toggleComments: this.toggleComments,
        isPlaying: isPlaying,
        volume: volume,
        isHD: isHD,
        isFullscreen: isFullscreen,
        isVideoStream: isVideoStream,
        showComments: showComments,
        isCommentsEnabled: isCommentsEnabled,
        isVideoFile: isVideoFile,
        selectedResolution: selectedResolution,
        onSelectResolution: this.onSelectResolution,
        isStreamHighDef: isStreamHighDef,
        resolutions: resolutions,
        captions: (0, _lodash["default"])(asset, "assetFiles.VTT_CAPTION", []),
        onSelectCaption: this.onSelectCaption,
        selectedCaption: selectedCaption
      })))) : customPlaceholder || _react["default"].createElement(_VideoPlaceholder["default"], null);
    }
  }]), PlayerComponent;
}(_react.Component),
    _default = PlayerComponent;

exports["default"] = _default;